


































import { Vue } from 'vue-property-decorator'
import '../../styles/reports-tab.css'
import { cisStar } from '@coreui/icons-pro'
import { CIcon } from '@coreui/icons-vue'

interface IReportFavorite {
  reportId: string
  reportName: string
  id: number
}

export default Vue.extend({
  data: function () {
    return {
      loading: true,
      reportFavorites: [] as IReportFavorite[],
      standardStarIcon: cisStar,
    }
  },
  mounted: async function () {
    this.reportFavorites = (await (
      await fetch('/api/favorites?reportsOnly=true')
    ).json()) as IReportFavorite[]
    this.loading = false
  },
  components: {
    CIcon,
  },
  methods: {
    removeFavorite(favoriteId) {
      this.$emit('remove-favorite', favoriteId)

      this.reportFavorites = this.reportFavorites.filter(
        (mdrf) => mdrf.id !== favoriteId
      )
    },
  },
})
